import React, { forwardRef, useRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { Warning, Info } from '../../../icons';
import { NA_VALUES } from '../../constants';

export const DownloadInfoAlert = ({
  className,
  downloadLink,
  informationLink,
}) => {
  const modalRef = useRef();

  return (
    <>
      <div role="alert" className={twMerge('alert flex', className)}>
        <div className="flex w-full items-center">
          <Warning className={'inline-block h-6 w-6 shrink-0 mr-2'} />
          <p className="m-0">
            Aplikacja obsługuje wyłącznie pliki w formatach: CSV (rozdzielane
            przecinkiem) i XLSX (Excel)
          </p>
          <button
            onClick={() => modalRef?.current?.showModal()}
            className="ml-auto btn btn-sm border border-base-300"
          >
            Pokaż wymagania
          </button>
        </div>
      </div>
      <div role="alert" className={twMerge('alert flex mt-4', className)}>
        <div className="flex w-full items-center">
          <Info className="inline-block h-6 w-6 shrink-0 mr-2" />
          <span className="inline-block">
            Pobierz przykładowe dane jeśli chcesz tylko przetestować działanie
            aplikacji.
          </span>
          <a
            href={informationLink}
            className="ml-auto btn btn-sm border border-base-300"
          >
            Informacje o danych
          </a>
          <a href={downloadLink} className="ml-3 btn btn-sm btn-secondary">
            Pobierz
          </a>
        </div>
      </div>
      <ModalAllRequirements ref={modalRef} />
    </>
  );
};

const ModalAllRequirements = forwardRef(function Modal(props, ref) {
  return (
    <dialog className="modal text-left" ref={ref}>
      <div className="modal-box">
        <h3 className="font-bold text-xl sm:text-2xl text-info mt-0 mr-12">
          <Info className={'inline-block mr-2 -mt-[7px]'} />
          Wymagania dotyczące danych
        </h3>
        <p>
          Aby poddać dane analizie, konieczne jest spełnienie następujących
          warunków:
        </p>
        <ul className="ml-6 mt-3">
          <li>Maksymalny rozmiar pliku: 2MB</li>
          <li>Format CSV lub XLSX</li>
          <li>Co najmniej jedna kolumna tekstowa</li>
          <li>Co najmniej 3 kolumny liczbowe</li>
          <li>Co najmniej 6 rzędów danych</li>
          <li>Wszystkie komórki powinny zawierać dane*</li>
        </ul>
        <p className="text-xs">
          *System traktuje jako brak danych również komórki oznaczone jako:{' '}
          {NA_VALUES.join(', ')}.
        </p>
        <div className="modal-action">
          <form method="dialog">
            <button className="btn btn-secondary">Zamknij</button>
          </form>
        </div>
      </div>
    </dialog>
  );
});
